// STRATIQ Advisor Catalogue (Doc 20 §7).
// 10 advisors. Real names from the doc, matched to existing operator images.
// The chat opens with one advisor. If the conversation drifts into another
// specialism, that advisor offers to swap to the right specialist.

export const ADVISORS = [
  {
    id: "sarah",
    name: "Sarah K.",
    role: "Senior Strategy Advisor",
    img: "/operators/sophie.webp",
    accent: "from-blue-500 to-indigo-700",
    specialism: "Tier recommendation, fit assessment, overall strategy",
    triggers: ["not sure", "what fits", "where do i start", "help me understand", "advice", "strategy"],
    isDefault: true,
    intro: "Hey, I'm Sarah, Senior Strategy Advisor at STRATIQ. Tell me a bit about your business and what you're trying to fix, and I'll point you in the right direction.",
  },
  {
    id: "marcus",
    name: "Marcus T.",
    role: "Production Director",
    img: "/operators/marcus.webp",
    accent: "from-slate-600 to-slate-900",
    specialism: "Stack A, Stack B, technical site builds, performance",
    triggers: ["site build", "stack a", "stack b", "website build", "technical", "rebuild", "performance", "load speed", "design"],
    intro: "Hey, I'm Marcus, Production Director at STRATIQ. I head the build side, sites, stacks, and the technical lift. What are you trying to ship?",
  },
  {
    id: "priya",
    name: "Priya R.",
    role: "AI Workforce Specialist",
    img: "/operators/priya.webp",
    accent: "from-violet-500 to-purple-700",
    specialism: "Voice AI, Conversation AI, automation hub, CRM integration",
    triggers: ["voice ai", "ai agent", "ai workforce", "automation", "crm", "automations", "chatbot", "ai receptionist", "ai assistant"],
    intro: "Hey, I'm Priya, AI Workforce Specialist. I handle Voice AI, Conversation AI, and how we wire automations into your business. What are you looking to automate?",
  },
  {
    id: "james",
    name: "James O.",
    role: "Content Autopilot Lead",
    img: "/operators/liam.webp",
    accent: "from-emerald-500 to-teal-700",
    specialism: "SEO content, social repurposing, blog publishing pipeline",
    triggers: ["content", "seo", "blog", "social", "instagram", "tiktok", "linkedin", "youtube", "ranking", "google", "keywords"],
    intro: "Hey, I'm James, Content Autopilot Lead at STRATIQ. SEO content, social repurposing, blogs, all the publishing engine. What's the content gap right now?",
  },
  {
    id: "elena",
    name: "Elena V.",
    role: "Pricing & Onboarding Advisor",
    img: "/operators/mei.webp",
    accent: "from-amber-500 to-orange-600",
    specialism: "Tier comparison, pricing fit, billing",
    triggers: ["pricing", "price", "cost", "tier", "tiers", "how much", "subscription", "billing", "monthly", "core", "growth", "pro", "elite", "what does it cost"],
    intro: "Hey, I'm Elena, Pricing and Onboarding Advisor. I help you pick the right tier and get the billing set up cleanly. What's the budget you've got in mind?",
  },
  {
    id: "david",
    name: "David W.",
    role: "Client Success Manager",
    img: "/operators/connor.webp",
    accent: "from-cyan-500 to-blue-700",
    specialism: "90 day journey, onboarding, post launch support",
    triggers: ["next steps", "onboarding", "process", "post launch", "what happens after", "timeline", "how long", "90 day", "kickoff", "go live"],
    intro: "Hey, I'm David, Client Success at STRATIQ. I look after the 90 day journey from kickoff to compounding. What stage are you at?",
  },
  {
    id: "hannah",
    name: "Hannah L.",
    role: "Brand & Positioning Lead",
    img: "/operators/aisha.webp",
    accent: "from-pink-500 to-rose-600",
    specialism: "Brand voice, messaging, copy direction",
    triggers: ["brand", "voice", "messaging", "copy", "tone", "positioning", "name", "tagline", "logo"],
    intro: "Hey, I'm Hannah, Brand and Positioning at STRATIQ. Voice, copy direction, how your business sounds to the market. What's not landing?",
  },
  {
    id: "tom",
    name: "Tom B.",
    role: "Operations Advisor",
    img: "/operators/jake.webp",
    accent: "from-indigo-500 to-blue-700",
    specialism: "Integrations, workflows, calendar and email systems",
    triggers: ["integration", "workflow", "calendar", "email", "tools", "stack", "zapier", "make", "operations", "google workspace", "outlook"],
    intro: "Hey, I'm Tom, Operations Advisor. Integrations, workflows, calendars, email tooling. Where's the workflow leak?",
  },
  {
    id: "amelia",
    name: "Amelia P.",
    role: "Industries Specialist",
    img: "/operators/jade.webp",
    accent: "from-fuchsia-500 to-pink-700",
    specialism: "Industry fit. Trades, hospitality, healthcare, beauty, legal, wellness",
    triggers: ["industry", "trades", "plumber", "plumbing", "electrician", "barber", "salon", "beauty", "hairdresser", "dentist", "clinic", "healthcare", "vet", "lawyer", "solicitor", "cafe", "restaurant", "hospitality", "gym", "wellness", "service business"],
    intro: "Hey, I'm Amelia, Industries Specialist. I know how STRATIQ fits per niche, trades, beauty, healthcare, hospitality and more. Which industry are you in?",
  },
  {
    id: "ryan",
    name: "Ryan H.",
    role: "Founder Liaison",
    img: "/operators/ryan.webp",
    accent: "from-yellow-500 to-amber-700",
    specialism: "Founder calls with Aaron, partnership inquiries, ELITE strategy, escalations",
    triggers: ["aaron", "founder", "partnership", "partner", "elite", "enterprise", "custom", "escalate", "speak directly", "call directly"],
    intro: "Hey, I'm Ryan, Founder Liaison at STRATIQ. I sit closest to Aaron and handle partnerships, ELITE level conversations, and anything that needs his eyes. What do you need to bring to him?",
  },
];

export const DEFAULT_ADVISOR = ADVISORS.find(a => a.isDefault) || ADVISORS[0];

export function getAdvisor(id) {
  return ADVISORS.find(a => a.id === id) || DEFAULT_ADVISOR;
}
